import React, { useEffect, useState, Suspense } from "react";
import { Redirect, Route, Switch, withRouter , useLocation} from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import { getUserByToken, getAccountByToken } from "./app/crud/auth.crud";
import { LayoutSplashScreen } from "./_metronic";
import { useDispatch } from "react-redux";
import * as AlertState from "./app/store/ducks/auth.duck";
import Intercom from "intercom-react";
import Drift from "react-driftjs";
import Profitwell from "profitwell-component";
import { fetchCRMList } from "./app/crud/crm.crud";
import { setCRMAction, setPlanAction } from "./app/store/actions";
import { LayoutContextProvider } from "./_metronic";
import Layout from "./_metronic/layout/Layout";
import lazyWithRetry from "./app/helpers/lazyWithRetry";
import { getCurrentSubscription } from "./app/crud/biling.crud";
import * as routerHelpers from "./app/router/RouterHelpers";
import { setAccountsList } from "./app/store/reducers/accountsSlice";
import { setCrmList } from "./app/store/reducers/crmSlice";
import { setSubscriptionList } from "./app/store/reducers/subscriptionSlice";
import { getAllUsers } from "./app/crud/info.crud";
import { getUsersV3 } from "./app/crud/info.crud";
import { getAllGroup } from "./app/crud/info.crud";
import { setUsersList } from "./app/store/reducers/usersSlice";
import { setGroupsList } from "./app/store/reducers/groupsSlice";
import { ProfileRoutes } from "./app/router/ProfileRoutes";
import { setAccount } from "./app/store/actions";
import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";
import * as Sentry from "@sentry/react";
import { LayoutLoader } from "./_metronic/layout/loader/Loader";
import { actions } from "./_metronic/ducks/builder";
import { fetchUsersThunk } from "./app/store/reducers/usersSlice";

const FormPDF = lazyWithRetry(() => import("./app/pages/PDF/FormPDF"));
const ExercisePdf = lazyWithRetry(() => import("./app/pages/PDF/ExercisePdf"));
const EventPdf = lazyWithRetry(() => import("./app/pages/PDF/EventPdf"));
const WorkoutPdf = lazyWithRetry(() => import("./app/pages/PDF/WorkoutPdf"));

const ProfileWorkoutPdf = lazyWithRetry(() =>
  import("./app/pages/PDF/ProfileWorkoutPdf")
);

const ProgramPdf = lazyWithRetry(() => import("./app/pages/PDF/ProgramPdf"));

const AuthPage = lazyWithRetry(() => import("./app/pages/auth/AuthPage"));
const ReportPDF = lazyWithRetry(() => import("./app/pages/PDF/ReportPDF"));
const RefreshPassword = lazyWithRetry(() =>
  import("./app/pages/auth/RefreshPassword")
);
const AcceptInvitation = lazyWithRetry(() =>
  import("./app/pages/auth/AcceptInvitation")
);
const LogoutPage = lazyWithRetry(() => import("./app/pages/auth/Logout"));
const ErrorsPage = lazyWithRetry(() => import("./app/pages/errors/ErrorsPage"));

const ProfileList = lazyWithRetry(() => import("./app/pages/home/ProfileList"));

const ProfileCreate = lazyWithRetry(() =>
  import("./app/pages/home/ProfileCreate")
);

const AccountInfo = lazyWithRetry(() => import("./app/pages/home/AccountInfo"));

const Metrics = lazyWithRetry(() => import("./app/pages/home/Metrics"));

const Overview = lazyWithRetry(() => import("./app/pages/home/Overview"));

const ProfileInfo = lazyWithRetry(() => import("./app/pages/home/ProfileInfo"));

const AccountSetting = lazyWithRetry(() => import("./app/pages/home/Setting"));

const Goals = lazyWithRetry(() => import("./app/pages/home/Goals"));

const Program = lazyWithRetry(() => import("./app/pages/home/Program"));
const Testing = lazyWithRetry(() =>
  import("./app/pages/home/TestingTabs/Testing")
);
const Report = lazyWithRetry(() => import("./app/pages/home/Report"));
const UserList = lazyWithRetry(() => import("./app/pages/home/User/UserList"));
const UserCreate = lazyWithRetry(() =>
  import("./app/pages/home/User/UserCreate")
);
const GroupList = lazyWithRetry(() =>
  import("./app/pages/home/Group/GroupList")
);
const GroupCreate = lazyWithRetry(() =>
  import("./app/pages/home/Group/GroupCreate")
);

const MetricsList = lazyWithRetry(() => import("./app/pages/home/MetricsList"));
const GoalsList = lazyWithRetry(() => import("./app/pages/home/GoalsList"));
const Biling = lazyWithRetry(() => import("./app/pages/home/UpgradePlan"));

const Cancel = lazyWithRetry(() => import("./app/pages/home/Cancel"));
const СRMConnect = lazyWithRetry(() => import("./app/pages/home/CRM/Connect"));
const СRMGroup = lazyWithRetry(() => import("./app/pages/home/CRM/Group"));
const CRMUser = lazyWithRetry(() => import("./app/pages/home/CRM/User"));
const CRMEvent = lazyWithRetry(() => import("./app/pages/home/CRM/Event"));
const CRMProfile = lazyWithRetry(() => import("./app/pages/home/CRM/Profile"));
const Files = lazyWithRetry(() => import("./app/pages/home/Files"));
const Notes = lazyWithRetry(() => import("./app/pages/home/Notes/Notes"));

const ProfileTasks = lazyWithRetry(() =>
  import("./app/pages/home/ProfileTasks")
);
const ProfileCalendar = lazyWithRetry(() =>
  import("./app/pages/home/ProfileCalendar")
);

const ReportsList = lazyWithRetry(() =>
  import("./app/pages/home/Analytics/ReportsList/ReportsList")
);

const CreateReportLoader = lazyWithRetry(() =>
  import("./app/pages/home/Analytics/CreateReport/CreateReportLoader")
);

const SessionList = lazyWithRetry(() =>
  import("./app/pages/home/Sales/Session")
);

const LeadsList = lazyWithRetry(() => import("./app/pages/home/Sales/Leads"));

const OpportunitiesList = lazyWithRetry(() =>
  import("./app/pages/home/Sales/Opportunities")
);
const ForecastsList = lazyWithRetry(() =>
  import("./app/pages/home/Sales/Forecasts")
);

const PerformanceList = lazyWithRetry(() =>
  import("./app/pages/home/Sales/Performance")
);

const FormsList = lazyWithRetry(() =>
  import("./app/pages/home/Forms/FormsList/FormsList")
);

const CreateForm = lazyWithRetry(() =>
  import("./app/pages/home/Forms/CreateForm/CreateForm")
);

const Dashboard = lazyWithRetry(() =>
  import("./app/pages/home/Dashboard/Dashboard")
);
const TaskList = lazyWithRetry(() => import("./app/pages/home/Tasks/TaskList"));
const Calendar = lazyWithRetry(() =>
  import("./app/pages/home/Calendar/Calendar")
);
const ProgramsList = lazyWithRetry(() =>
  import("./app/pages/home/Programs/ProgramsList/ProgramsList")
);
const WorkoutsList = lazyWithRetry(() =>
  import("./app/pages/home/Workouts/WorkoutsList/WorkoutsList")
);
const ExercisesList = lazyWithRetry(() =>
  import("./app/pages/home/Exercises/ExercisesList/ExercisesList")
);
const CreateEditProgram = lazyWithRetry(() =>
  import("./app/pages/home/Programs/CreateEditProgram/CreateEditProgram")
);
const CreateEditWorkout = lazyWithRetry(() =>
  import("./app/pages/home/Workouts/CreateEditWorkout/CreateEditWorkout")
);

const CreateExercise = lazyWithRetry(() =>
  import("./app/pages/home/Exercises/CreateExercise/CreateExercise")
);

const EditCreateWorkout = lazyWithRetry(() =>
  import("./app/pages/home/ProgramTabs/EditCreateWorkout/EditCreateWorkout")
);

const ProfileSales = lazyWithRetry(() =>
  import("./app/pages/home/Sales/ProfileSales/ProfileSales")
);

const Login = lazyWithRetry(() => import("./app/pages/auth/Login"));

const Registration = lazyWithRetry(() =>
  import("./app/pages/auth/Registration")
);

const RegistrationTrial = lazyWithRetry(() =>
  import("./app/pages/auth/RegistrationTrial")
);

const ForgotPassword = lazyWithRetry(() =>
  import("./app/pages/auth/ForgotPassword")
);

const AppBuilder = withRouter((props) => {
  const { pathname } = useLocation();
  const { history } = props;
  const dispatch = useDispatch();
  const account = useSelector((state) => state.appData?.account);
  const lastLocation = useLastLocation();
  routerHelpers.saveLastLocation(lastLocation);
  const [intercom, setIntercom] = useState(false);
  const [drift, setDrift] = useState(false);
  const [userId, setUserId] = useState();
  const [isDriftVisible, setIsDriftVisible] = useState(false);

  // --- Use authToken for isAuthorized check --- 
  const { isAuthorized, userEmail, menuConfig, userLastLocation } = useSelector(
    ({ auth, urls, builder: { menuConfig } }) => {
      return {
        menuConfig,
        isAuthorized: auth.authToken != null, // Check authToken 
        userEmail: auth.user?.email,
        userLastLocation: routerHelpers.getLastLocation(),
      };
    },
    shallowEqual
  );

  // Drift handlers ...
  const handleDriftOpen = () => {
    setIsDriftVisible(true);
    
    try {
      if (window.drift && window.drift.api) {
        // Use the method we know works
        if (window.drift.api.widget && typeof window.drift.api.widget.show === 'function') {
          window.drift.api.widget.show();
        }
        // Fallback to older API if needed
        else if (typeof window.drift.api.show === 'function') {
          window.drift.api.show();
        }
        
        if (process.env.REACT_APP_DRIFT_INTERACTION_ID) {
          window.drift.api.startInteraction({ interactionId: +process.env.REACT_APP_DRIFT_INTERACTION_ID });
        }
      }
    } catch (e) {
      console.log('Error showing Drift widget:', e);
    }
  };

  const handleDriftClose = () => {
    setIsDriftVisible(false);
    
    try {
      // First try using stored API reference from ready event
      if (window.driftApi) {
        if (window.driftApi.widget && typeof window.driftApi.widget.hide === 'function') {
          window.driftApi.widget.hide();
          return;
        } else if (typeof window.driftApi.hide === 'function') {
          window.driftApi.hide();
          return;
        }
      }
      
      // Fall back to window.drift
      if (window.drift && window.drift.api) {
        // Try to use the proper hide method based on API version
        if (window.drift.api.widget && typeof window.drift.api.widget.hide === 'function') {
          window.drift.api.widget.hide();
        } else if (typeof window.drift.api.hide === 'function') {
          window.drift.api.hide();
        }
      }
    } catch (e) {
      console.log('Error hiding Drift widget:', e);
    }
  };

  // Popstate handler
  useEffect(() => {
    const handlePopState = () => {
      const previousLocation = routerHelpers.getPreviousLocation();
      if (previousLocation && previousLocation !== pathname) {
        history.push(previousLocation);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [pathname, history]);

  // hideWidget setup
  const hideWidget = (event) => {
    // console.log('Drift event fired:', event);
    setIsDriftVisible(false);
    
    try {
      if (window.drift && window.drift.api) {
        // Use the method we know works
        if (window.drift.api.widget && typeof window.drift.api.widget.hide === 'function') {
          window.drift.api.widget.hide();
        } 
        // Fallback to older API if needed
        else if (typeof window.drift.api.hide === 'function') {
          window.drift.api.hide();
        }
      }
    } catch (e) {
      console.log('Error hiding Drift widget:', e);
    }
  };

  // Set up global access to hide function
  window.hideDriftWidget = hideWidget;

  // Drift event handlers setup
  useEffect(() => {
    if (drift && userId && process.env.REACT_APP_DRIFT_CHAT !== "disable") {
      // Set up a check for when Drift becomes available
      const checkForDrift = setInterval(() => {
        if (window.drift) {
          clearInterval(checkForDrift);
          
          // Set up global access to open function
          window.handleOpenDriftChat = () => {
            handleDriftOpen();
          };
          
          // Register event handlers
          window.drift.on('ready', function(api) {
            try {
              // Store API for global access
              window.driftApi = api;
              
              // Initially hide the widget
              if (api.widget && typeof api.widget.hide === 'function') {
                api.widget.hide();
              } else if (typeof api.hide === 'function') {
                api.hide();
              }
              
              setIsDriftVisible(false);
            } catch (e) {
              console.log('Error in Drift ready handler:', e);
            }
          });
          
          // Register event handlers for closing
          window.drift.on('sidebarClose', hideWidget);
          window.drift.on('chatClose', hideWidget);
        }
      }, 100);
      
      // Clear the interval after a timeout to prevent it running forever
      const timeoutId = setTimeout(() => {
        clearInterval(checkForDrift);
      }, 10000);
      
      return () => {
        clearInterval(checkForDrift);
        clearTimeout(timeoutId);
      };
    }
  }, [drift, userId]);

  // Global openDriftChat listener
  useEffect(() => {
    const handleOpenDriftChat = () => {
      handleDriftOpen();
    };

    window.addEventListener('openDriftChat', handleOpenDriftChat);
    return () => window.removeEventListener('openDriftChat', handleOpenDriftChat);
  }, []);

  // --- Main Data Fetching Effect (Reverted Dependencies) ---
  useEffect(() => {
    if (!isAuthorized) {
      Sentry.setUser(null);
      dispatch(actions.setLoaderScreen(false));
      return;
    }
    let sentryUserId;
    // Use Promise.allSettled to wait for all critical fetches
    Promise.allSettled([
      getAccountByToken()
        .catch(err => {
            throw err;
        }),
      getUserByToken()
        .catch(err => {
            throw err;
        })
        .then(userRes => {
          dispatch(AlertState.actions.fulfillUser(userRes.data));
          // Setup intercom/drift based on userRes
          sentryUserId = userRes.data.data.id;
          setIntercom({
            email: userRes.data.data.email,
            created_at: userRes.data.data.emailVerifiedAt,
            name: `${userRes.data.data.firstName} ${userRes.data.data.lastName}`,
          });
          setDrift({
            email: userRes.data.data.email,
            name: `${userRes.data.data.firstName} ${userRes.data.data.lastName}`,
            first_name: userRes.data.data.firstName,
            last_name: userRes.data.data.lastName,
            company: userRes.data.data.company_name,
          });
          
          return getCurrentSubscription().then(subRes => {
            dispatch(setPlanAction(subRes.data.data));
            dispatch(setSubscriptionList(subRes.data.data));
            // Setup Appcues if needed
            if (subRes.data.data && subRes.data.data.plan) {
                window.Appcues.identify(userRes.data.data.id, {
                  name: `${userRes.data.data.firstName} ${userRes.data.data.lastName}`,
                  email: userRes.data.data.email,
                  created_at: userRes.data.data.emailVerifiedAt,
                  company_name: userRes.data.data.company_name,
                  plan: subRes.data.data.plan.name,
                  plan_tier: subRes.data.data.plan.id,
                  role: userRes.data.data.roles,
                });
            }
            return subRes; 
          });
        })
    ]).then(results => {
      const accountResult = results[0];
      if (accountResult.status === 'fulfilled') {
        setUserId(accountResult.value.data.data.service_customer_id);
        dispatch(setAccountsList(accountResult.value.data.data));
        dispatch(setAccount(accountResult.value.data.data));
        Sentry.setUser({ id: sentryUserId, tm_user_id: sentryUserId, tm_account_id: accountResult.value.data.data.id });
      }

      const userSubResult = results[1];
      if (userSubResult.status === 'rejected') {
          setDrift(false);
          setIntercom(false);
      }

      if (window.Appcues) window.Appcues.page();

    }).finally(() => {
       dispatch(actions.setLoaderScreen(false));
    });

  }, [isAuthorized, dispatch]);

  // Fetch CRM List Effect
  useEffect(() => {
    if (account?.id) {
      fetchCRMList(account.id).then((res) => {
        if (res?.data?.list) {
          dispatch(setCRMAction(res.data.list));
          dispatch(setCrmList(res.data.list));
        }
      }).catch(err => {
      });
    }
  }, [account, dispatch]); 

  // Fetch Users Effect
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        await dispatch(fetchUsersThunk());
      } catch (error) {
      }
    };
    if (isAuthorized) fetchUsers();
  }, [isAuthorized, dispatch]); 

  // Fetch Groups Effect
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await getAllGroup();
        dispatch(setGroupsList(res.data.data));
      } catch (error) {
      }
    };

    if (isAuthorized) fetchGroups();
  }, [isAuthorized, dispatch]); 

  // --- Render Logic (Reverted) --- 
  const renderUserRoutes = () => {
    if (!account) {
      return null;
    }
    // console.log("Account Name for redirection check:", account?.company_name);
    let redirectTo = "/profile-list";
    // SPECIAL CASE FOR CLUB4 FITNESS
    if (account?.company_name?.trim() === 'Club4 Fitness') {
      redirectTo = "/analytics"; //default to analytics page
    }
    return (
      <>
      {pathname.includes('/pdf') ?
      <>
        <Route
            path="/profile/:profileId/workout/:id/pdf"
            component={ProfileWorkoutPdf}
          />
        <Route path="/report/:id/:type/:data/pdf" component={ReportPDF} />
        <Route path="/form/:id/pdf" component={FormPDF} />
        <Route path="/exercise/:id/pdf" component={ExercisePdf} />
        <Route path="/events/:id/pdf" component={EventPdf} />
        <Route path="/workout/:id/pdf" component={WorkoutPdf} />
        <Route path="/program/:id/pdf" component={ProgramPdf} />
      </> :
      <Layout {...props}>
        <Suspense fallback={null}>
          <Switch>
            <Redirect exact from="/" to={redirectTo} />
            {redirectTo !== "/profile-list" && <Redirect exact from="/profile-list" to={redirectTo} />}

            <Route path="/profile/:id" component={ProfileRoutes} />

            <Route path="/dashboard/main" component={Dashboard} />
            <Route path="/dashboard/tasks" component={TaskList} />
            <Route path="/dashboard/calendar" component={Calendar} />

            <Route path="/account/info" component={AccountInfo} />
            <Route path="/account/setting" component={AccountSetting} />
            <Route path="/account/biling" component={Biling} />
            <Route path="/account/cancel" component={Cancel} />

            <Route path="/account/crm/connect" component={СRMConnect} />
            <Route path="/account/crm/group" component={СRMGroup} />
            <Route path="/account/crm/user" component={CRMUser} />
            <Route path="/account/crm/profile" component={CRMProfile} />
            <Route path="/account/crm/event" component={CRMEvent} />

            <Route path="/library/programs/list" component={ProgramsList} />
            <Route
              path="/library/programs/create"
              exact
              component={CreateEditProgram}
            />
            <Route path="/library/programs/:id" component={CreateEditProgram} />

            <Route path="/library/workouts/list" component={WorkoutsList} />
            <Route
              path="/library/workouts/create"
              exact
              component={CreateEditWorkout}
            />
            <Route path="/library/workouts/:workoutId" component={CreateEditWorkout} />

            <Route path="/library/exercises/list" component={ExercisesList} />
            <Route
              path="/library/exercises/create"
              exact
              component={CreateExercise}
            />

            <Route path="/library/forms/list" component={FormsList} />
            <Route path="/library/forms/create" exact component={CreateForm} />
            <Route path="/library/forms/:id" component={CreateForm} />

            <Route path="/profile-list" component={ProfileList} />
            <Route path="/profile-create" component={ProfileCreate} />

            <Route path="/user-list" component={UserList} />
            <Route path="/user-create" component={UserCreate} />

            <Redirect exact from="/analytics" to="/analytics/reports-list" />
            <Route path="/analytics/reports-list" component={ReportsList} />
            <Route path="/analytics/new_report/:id" component={CreateReportLoader} />
            <Route path="/analytics/report/:id" component={CreateReportLoader} />

            <Route path="/group-list" component={GroupList} />
            <Route path="/group-create" component={GroupCreate} />

            <Route path="/sales/session" component={SessionList} />
            <Route path="/sales/leads" component={LeadsList} />
            <Route path="/sales/opportunities" component={OpportunitiesList} />
            <Route path="/sales/forecasts" component={ForecastsList} />
            <Route path="/sales/performance" component={PerformanceList} />

            <Route path="/logout" component={LogoutPage} />

            <Route path="/error" component={ErrorsPage} />

            <Redirect to={redirectTo} />
          </Switch>
        </Suspense>
      </Layout>}
      </>
    );
  };
  const renderGuestRoutes = () => {
    return (
      <Switch>
        <Route path="/logout" component={LogoutPage} />

        <Route path="/refresh-password/:id" component={RefreshPassword} />
        <Route path="/accept-invitation/:id" component={AcceptInvitation} />

        <Route path="/auth/login" component={Login} />
        <Route path="/auth/sign-up" component={Registration} />

        <Route
          path="/auth/create-trial-account"
          component={RegistrationTrial}
        />

        <Route path="/auth/forgot-password" component={ForgotPassword} />

        <Redirect to="/auth/login" />

        <Route path="/error" component={ErrorsPage} />

        <Redirect to="/auth/login" />
      </Switch>
    );
  };

  if (process.env.REACT_APP_ENV !== "development") {
    const tagManagerArgs = {
      gtmId: "GTM-T4FZT7",
    };

    TagManager.initialize(tagManagerArgs);
  }

  return (
    <LayoutLoader> 
      {drift && userId && process.env.REACT_APP_DRIFT_CHAT !== "disable" && (
        <Drift
          appId="rzyz5e5by27m"
          userId={"USER-" + userEmail}
          attributes={drift}
          style={{
            bottom: "10px",
            display: "block"
          }}
          config={{
            hideWelcomeMessage: true,
            autoAssignee: false,
            autoHideWidget: true, // Ensure widget is hidden initially
            widgetWelcomeMessage: ''
          }}
          onLoad={() => {
            // Try to hide the widget immediately after load
            setTimeout(() => {
              try {
                if (window.drift && window.drift.api && window.drift.api.widget && 
                    typeof window.drift.api.widget.hide === 'function') {
                  window.drift.api.widget.hide();
                }
              } catch (e) {
                console.log('Error hiding widget on load:', e);
              }
            }, 100);
          }}
        />
      )}
      {intercom && process.env.REACT_APP_INTERCOM_CHAT !== "disable" && (
        <Intercom appId="hetr4i01" user={intercom} />
      )}
      {!!userId && (
        <Profitwell
          authToken="61437c71cb6da32d50cdf0c07719cdb7"
          email={`${userId}`}
        />
      )}
      {isAuthorized ? renderUserRoutes() : renderGuestRoutes()} 
    </LayoutLoader>
  );
});

export default AppBuilder;
